import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('documentOverview')

export default {
    data() {
        return {
            impactButtonIsLoading: false,
            multipleSelection: []
        }
    },
    computed: {
        ...mapState([
            'doctype',
            'docid',
            'step',
            'docNumberFormat',
            'unitNumberFormat',
            'canEditDocument',
            'canBaseEditDocument',
        ]),
        canImpact: function() {
            return this.canBaseEditDocument
        },
        promoteButton : function () {
            if (! this.canImpact || this.impactButtonIsDisable) {
                return 'btn-default btn-disabled'
            }
            return 'btn-primary'
        },
        linkButton : function () {
            if (! this.canImpact) {
                return 'btn-default btn-disabled'
            }
            return 'btn-secondary'
        },
        formattedTotal: function () {
            if (this.original.length == 0) {
                return 0
            }
            return this.original.reduce((accumulator, doc) => {
                return accumulator + parseFloat(doc.totalAmount)
            }, 0)
        },
        impactButtonIsDisable: function () {
            if (this.impactButtonIsLoading) {
                return true
            }

            if (! this.canImpact) {
                return true
            }

            const original = this.original
            const selection = this.multipleSelection
            if (original.length === selection.length && original.sort().every(function(value, index) { return value === selection.sort()[index]})) {
                return true
            }
            return false
        }
    },
    created: function () {
        this.getLinkedResource(this.context)
            .then(() => this.checkRows())
    },
    methods: {
        displaySaasBoolean: function (value) {
            if (value) {
                return this.$l10n.__('Oui')
            }
            return this.$l10n.__('Non')
        },
        handleSelectionChange: function (val) {
            this.multipleSelection = val
        },
        canProcess : function(row, index) {
            if (typeof row.canEdit === 'undefined') {
                return this.canImpact
            }
            return this.canImpact && row.canEdit
        },
        removeLink : function (link, context) {
            this.deleteLink({
                id: link.id,
                context: context
            })
                .then(() => {
                    Push.success(this.$l10n.__('Ressource déliée'))
                    if (link.processMargin) {
                        this.impact(true)
                    }
                })
        },
        impact : function (force = false) {
            if (!force && this.impactButtonIsDisable) {
                return
            }

            this.impactButtonIsLoading = true
            const payload = {
                context: this.context,
                ids: this.multipleSelection.map(row => parseInt(row.id))
            }

            this.processMargin(payload).then(
                (success) => {
                    Push.info(this.$l10n.__('Marge en cours de calcul'))
                    this.checkRows()
                    this.$emit('update')
                    this.impactButtonIsLoading = false
                },
                (failure) => {
                    failure.response.data.error.message.map((error) => {
                        Push.error(error)
                    })
                    this.impactButtonIsLoading = false
                }
            )
        },
        checkRows: function () {
            this.$refs.multipleTable.clearSelection()
            this.original.forEach((document) => {
                this.$refs.multipleTable.toggleRowSelection(document, true)
            })
        },
        ...mapActions([
            'getLinkedResource',
            'processMargin',
            'deleteLink'
        ])
    }
}